jQuery(function($){
		
	$(".product_info_overlay_inner2").click(function(e){
		window.location = $(this).data("url");
	});

	$('input#rendement_mini_filter').rangeslider({
		polyfill: false,
		onSlide: function(position, value) {
			if(parseInt(value) != 0){
				$("input#rendement_mini_filter + .rangeslider .rangeslider__handle").attr("data-before", value+" %");
			}else{
				$("input#rendement_mini_filter + .rangeslider .rangeslider__handle").attr("data-before", "");
			}
		},
		onInit: function() {
			var value = jQuery("#rendement_mini_filter").val();
			if(parseInt(value) != 0){
				$("input#rendement_mini_filter + .rangeslider .rangeslider__handle").attr("data-before", value+" %");
			}else{
				$("input#rendement_mini_filter + .rangeslider .rangeslider__handle").attr("data-before", "");
			}

		}
	});


	$('input#puissance_filter').rangeslider({
		polyfill: false,
		onSlide: function(position, value) {
			if(parseInt(value) != 0){
				$("input#puissance_filter + .rangeslider .rangeslider__handle").attr("data-before", value+" KW");
			}else{
				$("input#puissance_filter + .rangeslider .rangeslider__handle").attr("data-before", "");
			}
		},
		onInit: function() {
			var value = jQuery("#puissance_filter").val();
			if(parseInt(value) != 0){
				$("input#puissance_filter + .rangeslider .rangeslider__handle").attr("data-before", value+" KW");
			}else{
				$("input#puissance_filter + .rangeslider .rangeslider__handle").attr("data-before", "");
			}
		}
	});

	$("#filter-form form").removeClass("hidden");
	$("#filter-form:not(.open) form").hide();
	$('[data-toggle="tooltip"]').tooltip();
	$("#filter-form .openclose").click(function(){
		$("#filter-form").toggleClass("open");
		$("#filter-form form").slideToggle(250);
	});

	$("#contact-form-product-trigger").click(function(e){
		$("#contact-form-product").slideToggle( 250);
		e.preventDefault();
	});


	
	var windowWidth = $(window).innerWidth();

    //console.log("tailles",elementorFrontend.config.responsive.breakpoints);
    if (elementorFrontend.config.responsive.breakpoints) {

        var windowMinWidth = elementorFrontend.config.responsive.breakpoints.tablet.value;
    } else {
        var windowMinWidth = 768;
    }
    var windowResponsiveMobile = windowWidth < windowMinWidth;
    function swapChildren(obj1, obj2) {
        var temp = obj2.children().detach();
        obj2.empty().append(obj1.children().detach());
        obj1.append(temp);
    }
	
    function toggleMobileStyles() {
        console.log("toggleMobileStyles");
        console.log("breakpoints", elementorFrontend.config.responsive.breakpoints);
        if (windowResponsiveMobile) {
            console.log('on passe le desktop en mobile');
			
            $("[id^='_desktop_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        } else {
            console.log('on passe mobile en desktop');
			
            $("[id^='_mobile_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        }
    }
    $(window).on('resize', function () {
        var _cw = windowWidth;
        var _mw = windowMinWidth;
        var _w = $(window).innerWidth();
        var _toggle = _cw >= _mw && _w < _mw || _cw < _mw && _w >= _mw;
        windowWidth = _w;
        windowResponsiveMobile = windowWidth < windowMinWidth;
        //console.log('_toggle', _toggle)
        if (_toggle) {
            toggleMobileStyles();
        }
    });
    $(document).ready(function () {
        if (windowResponsiveMobile) {
            toggleMobileStyles();
        }
    });

});
